import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { FastExpressionLanguageActionType, FastExpressionLanguageStoreElement } from './FastExpressionLanguageReducer.types';

const initialState = Immutable.fromJS({
  fetching: false,
  operators: null,
});

export const FastExpressionLanguageReducer = handleActions(
  {
    RESPONSE_FAST_EXPRESSION_LANGUAGE: (state: FastExpressionLanguageStoreElement, action: FastExpressionLanguageActionType) =>
      state.merge(
        Immutable.fromJS({
          fetching: false,
          operators: Immutable.fromJS(action.payload),
        })
      ),
    REQUEST_FAST_EXPRESSION_LANGUAGE: (state: FastExpressionLanguageStoreElement) =>
      state.merge(
        Immutable.fromJS({
          fetching: true,
        })
      ),
    RESPONSE_FAST_EXPRESSION_LANGUAGE_FAILURE: (state: FastExpressionLanguageStoreElement) =>
      state.merge(
        Immutable.fromJS({
          fetching: false,
        })
      ),
    // @ts-ignore
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);
